import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children, fallback = null }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return fallback;
  }

  return children;
}

export default ProtectedRoute;
